import { MissionWordHero } from './MissionWordHero';

export default function AboutSection() {
  return (
    <section className="relative w-full">
      <MissionWordHero />
    </section>
  );
}
